export type PermissionRule = 'ANY' | 'ALL'

export const guard = (
  rule: PermissionRule,
  guardPermissions: string[],
  userPermissions?: string[],
): boolean => {
  if (!guardPermissions?.length) {
    return true
  }

  if (!userPermissions?.length) {
    return false
  }

  if (rule === 'ALL') {
    return guardPermissions.every((p) => userPermissions.includes(p))
  }

  return guardPermissions.some((p) => userPermissions.includes(p))
}

/* Mirrors modules/nuxt-auth0's auth0-permissions; keep the two in sync with the Auth0 permission list */
export const PERMISSIONS = <const>{
  readConfig: 'read:config',
  writeConfig: 'write:config',
  readSystem: 'read:system',
  writeSystem: 'write:system',
  readTeamContent: 'read:team-content',
  writeTeamContent: 'write:team-content',
  publishPolicies: 'publish:policies',
  readUsersAll: 'read:users-all',
  writeUsersAll: 'write:users-all',
  readWorkspacesAll: 'read:workspaces-all',
  writeWorkspacesAll: 'write:workspaces-all',
}

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]

export const WORKSPACE_PERMISSION = <const>{
  readAnalytics: 'read:analytics',
  readPhi: 'read:phi',
  readWorkspace: 'read:workspace',
  writeWorkspace: 'write:workspace',
  readConnectorConfig: 'read:connector-config',
  writeConnectorConfig: 'write:connector-config',
  readConnector: 'read:connector',
  writeConnector: 'write:connector',
  readSystem: 'read:system',
  writeSystem: 'write:system',
}

export type WorkspacePermission =
  (typeof WORKSPACE_PERMISSION)[keyof typeof WORKSPACE_PERMISSION]

export const getWorkspacePermission = (
  workspaceId: string,
  permission: WorkspacePermission,
): string => `workspace:${workspaceId}#${permission}`
